// Global styles first, so CSS modules can override them
import './i18n/i18n';
import '@fontsource-variable/geist';
import '@fontsource-variable/schibsted-grotesk';
import '@fontsource/instrument-serif/400.css';
import '@fontsource/instrument-serif/400-italic.css';
import 'lenis/dist/lenis.css';
import 'src/styles/global.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';

import AppRouter from './app/AppRouter';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
